export const recorrenciaEnum = {
    ANUAL: 1,
    MENSAL: 2,
    TRIMESTRAL: 3,
    SEMESTRAL: 4,
    DECENDIAL: 5,
    SEMANAL: 6
}